import React from "react";
import '../styles/HistorialTable.css';
import { HistorialOperacion } from "../types";

interface HistorialTableProps {
  historial: HistorialOperacion[];
  onEliminar: (id: number) => void;
  onFiltrarPorProducto: (id: number) => void;
  onFiltrarPorProveedor: (id: number) => void;
  tipo: 'compra' | 'venta';
}

const HistorialTable: React.FC<HistorialTableProps> = ({
  historial,
  onEliminar,
  onFiltrarPorProducto,
  onFiltrarPorProveedor,
  tipo,
}) => {
  return (
    <table className="historial-table">
      <thead>
        <tr>
          <th>Fecha</th>
          <th>Producto</th>
          <th>{tipo === "compra" ? "Proveedor" : "Cliente"}</th>
          <th>Cantidad</th>
          <th>Precio Unitario</th>
          <th>Total</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {historial.map((item) => (
          <tr key={item.id}>
            <td>{new Date(item.fecha).toLocaleDateString()}</td>
            <td>
              <button onClick={() => onFiltrarPorProducto(item.producto_id)}>
                {item.Producto?.nombre}
              </button>
            </td>
            <td>
              {tipo === "compra" ? (
                <button onClick={() => item.proveedor_id && onFiltrarPorProveedor(item.proveedor_id)}>
                  {item.Proveedor?.nombre || 'N/A'}
                </button>
              ) : (
                item.cliente || 'Cliente General'
              )}
            </td>
            <td>{item.cantidad}</td>
            <td>${item.precioUnitario}</td>
            <td>${item.total}</td>
            <td>
              <button onClick={() => onEliminar(item.id)}>Eliminar</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default HistorialTable;
